import { getLangCode } from "./getLangCode";

export const setAnalyticsConfig = () => {
  const oneDs = document.querySelector(".oneds-config");
  const langCode = getLangCode();
  oneDs.setAttribute("data-market", langCode);
  oneDs.setAttribute("data-env", process.env.REACT_APP_ANALYTICS_ENV);
};